import { render, staticRenderFns } from "./workshops.vue?vue&type=template&id=1f6594d4"
import script from "./workshops.vue?vue&type=script&lang=js"
export * from "./workshops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports